import React, {useContext} from 'react';
import {SystemConfigCtx} from '@/contexts';
import {appHost, appBaseName} from '@/config';
import {blank} from '@/util';

const Footer = () => {
  const {siteCode} = useContext(SystemConfigCtx);

  if (blank(siteCode)) {
    return null;
  }

  const angularObjectPath = `{"root_url": "${appHost}${appBaseName}/"}`;

  return (
    <>
      {(siteCode === 'afs' || siteCode === 'ipc') && (
        <angular-footer config={angularObjectPath} />
      )}
    </>
  );
};

export default Footer;
